'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPropertyCampaign = undefined;

var _createProperty = require('ui-addon-upgrades/_core/common/data/upgradeData/transformers/createProperty');

var _campaigns = require('ui-addon-upgrades/_core/common/data/upgradeData/properties/campaigns');

var PROPERTY_KEY = 'campaign';

/**
 * @param {Object} upgradeData
 * @param {String} upgradeSource
 * @return {Object}
 */

var getPropertyCampaign = exports.getPropertyCampaign = function getPropertyCampaign(_ref) {
  var upgradeProduct = _ref.upgradeProduct;

  var propertyValue = _campaigns.campaigns[upgradeProduct];

  return (0, _createProperty.createProperty)(PROPERTY_KEY, propertyValue);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/data/upgradeData/transformers/getPropertyCampaign.js
// module id = 449
// module chunks = 3 4 5